import { Controller } from "@hotwired/stimulus";
import { renderChordPro } from "../lib/chordpro.js";

// Shows a song's ChordPro as chords over lyrics, with a toggle to view the raw
// source. The server renders the raw source in the `raw` target, so without
// JavaScript the page just shows the source.
export default class extends Controller {
  static targets = ["rendered", "raw", "toggle"];

  connect() {
    this.renderedTarget.replaceChildren(renderChordPro(this.rawTarget.textContent));
    this.showRaw(false);
    this.toggleTarget.hidden = false;
  }

  toggle() {
    this.showRaw(!this.renderedTarget.hidden);
  }

  showRaw(raw) {
    this.rawTarget.hidden = !raw;
    this.renderedTarget.hidden = raw;
    this.toggleTarget.setAttribute("aria-pressed", String(raw));
    this.toggleTarget.textContent = raw ? "Chords" : "Source";
    this.toggleTarget.setAttribute("aria-label", raw ? "Show chords" : "Show source");
  }
}
